import { SearchTerm } from "./SearchTerm";

const PresetActionSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        translationKey: "name",
        searchOnName: "trnName",
    },
    {
        heading: "Type",
        accessor: "type",
        translationKey: "type",
        searchOnName: "settingType.trnName",
    },
];

export default PresetActionSearch;
